import { makeStyles } from '@material-ui/styles';

export const useMakeRequestStyles = makeStyles(() => ({
  link: {
    color: '#424242',
  },
  goPurchases: {
    textDecoration: 'underline',
    color: '#1A1A1A',
    cursor: 'pointer',
    marginTop: 47,
  },
  divMessage: {
    marginTop: 30,
    marginBottom: (props) => (props.mobile ? 10 : 0),
  },
}));

export const useRequestContainerStyles = makeStyles(() => ({
  accordionSummary: {
    paddingRight: 0,
  },
  rootDetailAccordion: {
    marginLeft: (props) => (props.mobile ? '' : 50),
    marginRight: (props) => (props.mobile ? '' : 50),
  },
  boxContainer: {
    marginTop: (props) => (props.mobile ? 0 : 8),
    border: (props) => (props.mobile ? '1px solid #BCBCBC' : ''),
    borderBottomStyle: 'none',
  },
  accordion: {
    '&.MuiAccordion-root.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  container: {
    marginTop: 17,
    border: '1px solid #BCBCBC',
    borderRadius: 10,
    borderBottomStyle: 'none',
  },
  icon: {
    width: 64,
    height: 50,
    marginRight: 8,
  },
  title: {
    fontSize: '16px',
    font: 'Barlow Medium, Regular',
    color: '#000000',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '14px',
    font: 'Barlow Regular',
    color: '#464646',
    position: 'left',
  },
  arrowExpandIcon: {
    width: 100,
    height: 30,
  },
}));

export const useMotivesStyles = makeStyles(() => ({
  accordion: {
    '&.MuiAccordion-root.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  motiveContainer: {
    marginLeft: -64,
    marginRight: -64,
  },
  title: {
    opacity: 1,
    fontSize: 14,
    color: '#464646',
    fontWeight: 600,
  },
  container: {
    width: 'auto',
    height: 'auto',
    backgroundColor: '#F1F1F1',
    display: 'flex',
    justifyContent: 'center',
    padding: '25px',
    alignItems: 'center',
    borderTopStyle: 'solid',
    borderTopColor: '#6A148E',
    borderWidth: '1px',
  },
}));

export const usePageErrorFormStyles = makeStyles(() => ({
  descriptionTextfield: {
    width: '500px',
    height: '100px',
    font: 'Barlow Regular',
    fontSize: '54px',
    color: '#666666',
  },
  textTerms: {
    color: '#464646',
    fontSize: '14px',
    font: 'Barlow',
    textAlign: 'left',
    alignItems: 'center',
    display: 'flex',
  },
  sendButton: {
    width: '200px',
    height: '35px',
    borderRadius: '5px',
    font: 'Barlow',
  },
  selectIssues: {
    width: '500px',
    height: '40px',
  },
  label: {
    font: 'Barlow',
    fontSize: '16px',
    color: '#666666',
  },
  contButton: {
    textAlign: 'center',
  },
}));
export const usePageBallotCopyStyles = makeStyles(() => ({
  container: {
    backgroundColor: (props) => (props.mobile ? '#F1F1F1' : ''),
    display: 'flex',
    flexDirection: 'column',
    width: (props) => (props.mobile ? 'auto' : '100%'),
    padding: (props) => (props.mobile ? '24px 12px' : ''),
  },
  title: {
    color: '#464646',
    fontSize: '16px',
    font: 'Barlow, Semibold',
    marginBottom: 30,
  },
  contButton: {
    textAlign: 'center',
    marginTop: 15,
  },
  sendButton: {
    width: '200px',
    height: '35px',
    borderRadius: '5px',
    font: 'Barlow',
  },
  msgContainer: {
    width: (props) => (props.mobile ? '' : '75%'),
    margin: (props) => (props.mobile ? '' : 'auto'),
    marginBottom: 0,
  },
  titleRadioButton: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: 15,
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
  radioButton: {
    '& span': {
      fontSize: 16,
    },
  },
  button: {
    width: 200,
    margin: '0 auto',
  },
}));
